import { render, staticRenderFns } from "./KategoriZISPopup.vue?vue&type=template&id=502942e2&scoped=true"
import script from "./KategoriZISPopup.vue?vue&type=script&lang=js"
export * from "./KategoriZISPopup.vue?vue&type=script&lang=js"
import style0 from "./KategoriZISPopup.vue?vue&type=style&index=0&id=502942e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502942e2",
  null
  
)

export default component.exports